import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { BrandingService } from '../../core/services/branding.service';

@Directive({
    selector: '[brandingAttr]',
    standalone: false
})
export class BrandingAttrDirective {
  private hasView: boolean = false;

  constructor(private brandingService: BrandingService,
              private templateRef: TemplateRef<unknown>,
              private viewContainer: ViewContainerRef,
              ) { }

  @Input() set brandingAttr(brandingAttribute: string) {
    const attribute = this.brandingService.getBrandingInfoSnapshot()?.profile_attributes.find((item: any) => item.name === brandingAttribute);

    if (attribute) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView = true;
    } else if (!attribute && this.hasView) {
      this.viewContainer.clear();
      this.hasView = false;
    }
  }
}
